import * as React from 'react';
import * as moment from 'moment';
import { ICalendarAppText } from '../../custom/classes/calendar-text';
import { ICalendarState, IMonth, IDay, CalendarViewMode } from '../../classes/calendar';
import { IEvent } from '../../custom/classes/event';
import { connect, Dispatch } from 'react-redux';

import { ICalendarAppState } from '../../redux-state';
import { goToMonth } from '../../redux-state/actions/calendar.actions';

import MonthSelectionDropdownView from 'month-selection-dropdown.view';

interface IMonthSelectionDropdownExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
    currentMonth: moment.Moment;
    validMonths: moment.Moment[];
}

interface DispatchToProps {
    goToMonth: (date: moment.Moment) => void;
}

export type MonthSelectionDropdownProps = IMonthSelectionDropdownExternalProps & StateToProps & DispatchToProps;

export class MonthSelectionDropdownBase extends React.Component<MonthSelectionDropdownProps, any> {
    render() {
        return (
            <MonthSelectionDropdownView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IMonthSelectionDropdownExternalProps): StateToProps {
    return {
        text: state.calendarText,
        currentMonth: state.calendar.currentDate,
        validMonths: state.calendarSettings.monthsOnCalendar
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        goToMonth: (date: moment.Moment) => dispatch(goToMonth(date))
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(MonthSelectionDropdownBase);